import styled from '@emotion/styled'
import { CLOUDFRONT_BASE } from 'src/util/constants'

// backgrounds
const affiliateBase = `${CLOUDFRONT_BASE}/images/banners/ally`
const redBannerBase = `${affiliateBase}/banner-red`
const redBackgroundDesktop = `${redBannerBase}/ally-banner-desktop-pink.webp`

// chibis
export const redChibi = `${redBannerBase}/ally-banner-desktop-pink-chibi-tomoko.webp`

export const AffiliateBanner = styled.div`
  position: sticky;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  align-items: center;
  gap: 16px;
  top: 70px;
  height: 85px;
  background-image: url(${redBackgroundDesktop});
  background-size: auto 85px;
  background-position: right;
  z-index: 100;
  cursor: pointer;

  // animate the banner background to move from right to left
  animation: slide 500s linear infinite;

  @keyframes slide {
    from { background-position: 0 0; }
    to   { background-position: -10000px 0; }
  }

  @media (max-width: 690px) { gap: unset;}
`

export const DiscountText = styled.h2`
  font-family: 'Tilt Warp';
  font-size: 2.5rem !important;
  color: white;
  text-align: center;
  text-shadow: 0px 4px 2px rgba(0, 0, 0, 0.55);
  -webkit-text-stroke: 1px black;

  @media (max-width: 1305px) { font-size: 2rem !important; }
  @media (max-width: 1080px) { font-size: 1.75rem !important; }
  @media (max-width: 515px) { font-size: 1.5rem !important; }
`

export const Colored = styled.span`
  color: #FFFBA1;
`

export const RedChibi = styled.img`
  height: 85px;
`
